const PastIrishOralQuestions = {"Family and Personal Background":[
  "Cad is ainm duit?",
  "Cén aois thú?",
  "Cathain a bhíonn do bhreithlá ann?",
  "Cén comhartha stoidiaca atá agat?",
  "Inis dom faoi do theaghlach.",
  "Cé mhéad duine atá i do theaghlach?",
  "An bhfuil deartháireacha nó deirfiúracha agat?",
  "An réitíonn tú go maith le do theaghlach (nó le do chlann)?",
  "Cén tslí bheatha atá ag do thuismitheoirí?",
  "Céard a dhéanann do thuismitheoirí?",
  ],
  "Home and Local Area":[
  "Cá bhfuil tú i do chónaí?",
  "Déan cur síos ar do theach.",
  "Cén saghas tí atá agat?",
  "Inis dom faoin gceantar ina bhfuil tú i do chónaí.",
  "Déan cur síos ar d’áit chónaithe (do cheantar).",
  "An maith leat an ceantar sin?",
  "An maith leat do cheantar?",
  "An maith leat bheith i do chónaí sa bhaile mór / sa chathair?",
  "Conas a théann tú ar scoil gach maidin?",
  ],
  "School and Education":[
  "Inis dom faoi do scoil.",
  "Déan cur síos ar ghnáthlá scoile.",
  "Cad iad na hábhair atá á ndéanamh agat i mbliana?",
  "Cé na hábhair atá á ndéanamh agat ar scoil?",
  "Cén t-ábhar is fearr leat? Cén fáth?",
  "An gcaitheann sibh éide scoile?",
  "Cad iad rialacha na scoile?",
  "An mbíonn brú ort i mbliana?",
  "Cad é do mheas ar chóras na bpointí san Ardteist?",
  ],
  "Hobbies and Free Time":[
  "Cad iad na caitheamh aimsire atá agat?",
  "Cén caitheamh aimsire atá agat?",
  "Cad a dhéanann tú chun do scíth a ligean?",
  "An bhfuil spéis agat sa spórt?",
  "An imríonn tú spórt?",
  "Cad a dhéanann tú ag an deireadh seachtaine?",
  "An dtéann tú amach go minic?",
  "An dtéann tú go dtí an phictiúrlann go minic?",
  "An seinneann tú aon uirlis cheoil?",
  "An bhfuil uirlis cheoil á sheinm agat?",
  "Cén saghas ceoil is fearr leat?",
  "Cén banna ceoil is fearr leat?",
  "An mbreathnaíonn tú go minic ar an teilifís? Cén clár teilifíse is fearr leat?",
  ],
  "Work and Money":[
  "An bhfuil post páirtaimseartha agat?",
  "An bhfaigheann tú airgead póca?",
  "Cad a dhéanann tú leis an airgead sin?",
  "Conas a chaitheann tú d’airgead?",
  "An ólann tú deoch alcólach ó am go chéile?",
  ],
  "Travel and Holidays":[
  "An maith leat taisteal?",
  "Cén tír/tíortha ina raibh tú cheana féin?",
  "An raibh tú riamh thar lear?",
  "Ar mhaith leat dul thar lear?",
  "Cá dtéann tú ar saoire de ghnáth?",
  "Cad iad do phleananna don samhradh seo chugainn?",
  "Cad a rinne tú anuraidh le linn na laethanta saoire?",
  "An maith leat bia ó thíortha eile?",
  ],
  "Future Plans":[
  "Cad ba mhaith leat a dhéanamh tar éis na hArdteiste?",
  "Cad ba mhaith leat a dhéanamh tar éis na hArdteistiméireachta?",
  "Cad atá beartaithe agat don bhliain seo chugainn?",
  "An rachaidh tú go dtí an ollscoil?",
  "Ar mhaith leat dul chuig an ollscoil?",
  "Cén tslí bheatha ar mhaith leat a bheith agat amach anseo?",
  "Cén ghairm bheatha ar mhaith leat a bheith agat sa todhchaí?",
  ],
  "Social and Political Issues":[
  "An bhfuil suim agat sa pholaitíocht?",
  "Dá mbeifeá i do Thaoiseach, cad a dhéanfá?",
  "An gceapann tú go n-ólann daoine óga an iomarca alcóil?",
  "Dar leat, cad iad na fadhbanna is mó atá againn sa tír seo?",
  ],
  
};

export default PastIrishOralQuestions; 